import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import {
  InterfaceNameValue,
  RadioButtonGroup,
  InterfaceRadioButtonOption,
} from '@tiendanube/components';
import { PromotionalPriceType } from 'domains/Catalog/Products/productsServices';

interface OnChangeValue {
  name: string;
  value: PromotionalPriceType;
}

interface StockProps {
  value: PromotionalPriceType;
  onChange: ({ name, value }: OnChangeValue) => void;
}
function PromotionalPrice({ value, onChange }: StockProps): JSX.Element {
  const { t } = useTranslation([Domain.CATALOG]);

  const options: PromotionalPriceType[] = ['', 'true', 'false'];

  const labelOptions: InterfaceRadioButtonOption[] = options.map((value) => ({
    value,
    label: t(`products.filters.promotionalPrice.${value || 'all'}`),
  }));

  const handleChange = (data: InterfaceNameValue) => {
    onChange(data as OnChangeValue);
  };

  return (
    <RadioButtonGroup
      label={t('products.filter.promotionalPrice')}
      name="promotionalPrice"
      options={labelOptions}
      onChange={handleChange}
      value={value}
    />
  );
}

export default PromotionalPrice;
